import React, { Context, useContext } from "react";
import { capitalize } from "@material-ui/core";
import { IUploadContext, UploadMode, UploadFormat, MediaAccepted } from "../../../laco-common/base/models/upload";

export const DEFAULT_UPLOAD_CONTEXT: IUploadContext = {
	mode: UploadMode.SINGLE,
	path: "site/site_images",
	files: [],
};

export const UploadContext: Context<IUploadContext> = React.createContext<IUploadContext>(DEFAULT_UPLOAD_CONTEXT);

export default UploadContext;

// export type UploadContextProps = { uploadContext: IUploadContext };

// interface GenericFunctionType {
// 	<T>(x: T): string;
// }
// const genericFunction: GenericFunctionType = (x) => `doSomething with X ${x}`;

// export const withUploadContext = (Component) => (props: UploadContextProps & any) => (
// 	<UploadContext.Consumer>{(context) => <Component uploadContext={context} {...props} />}</UploadContext.Consumer>
// );

// export function withUploadContext<TProps>(Component: React.JSXElementConstructor<TProps>) {
// 	return (
// 		<UploadContext.Consumer>{(context) => <Component uploadContext={context} {...props} />}</UploadContext.Consumer>
// 	);
// }

export interface UploadContextProps {
	uploadContext: IUploadContext;
}

export function withUploadContext<T extends UploadContextProps = UploadContextProps>(
	WrappedComponent: React.ComponentType<T>
) {
	const ComponentWithContext = (props: Omit<T, keyof UploadContextProps>) => {
		const context: IUploadContext = useContext(UploadContext);
		return <WrappedComponent uploadContext={context} {...(props as T)} />;
	};

	// return (
	// 	<UploadContext.Consumer>{(context) => <ComponentWithContext uploadContext={context} />}</UploadContext.Consumer>
	// );
	return ComponentWithContext;
}

// = (Component) => (props: UploadContextProps & any) => (
// 	<UploadContext.Consumer>{(context) => <Component uploadContext={context} {...props} />}</UploadContext.Consumer>
// );

export const getAcceptedMediaDisplay = (mediaType: MediaAccepted): string => {
	if (!mediaType) return "Image / Video";
	switch (mediaType) {
		case MediaAccepted.AUDIO:
			return "Audio File";
		case MediaAccepted.IMAGE_VIDEO:
			return "Image / Video";
		default: {
			let value = capitalize(mediaType);
			return value;
		}
	}
};

export const getAcceptedFormatsByAcceptedMedia = (mediaType: MediaAccepted): UploadFormat => {
	if (mediaType === MediaAccepted.IMAGE_VIDEO)
		return (UploadFormat.IMAGE + ", " + UploadFormat.VIDEO) as UploadFormat;
	switch (mediaType) {
		case MediaAccepted.IMAGE:
			return UploadFormat.IMAGE;
		case MediaAccepted.VIDEO:
			return UploadFormat.VIDEO;
		case MediaAccepted.AUDIO:
			return UploadFormat.AUDIO;
	}
};
